module.exports = "pegasus/assets/email1-img10.png";